import React, { useEffect } from 'react';
import './Avatar.css';
import PropTypes from 'prop-types';

export default function Avatar(props) {
  const {
    name, size, fontSize, lineHeight,
  } = props;

  // Function to extract initials from the name
  function getInitials(names) {
    let initialsArray = [];
    let initialsFinal;
    const arr = names.split(' ');
    if (arr.length > 1) {
      // Get initials from the first character of each word
      for (let i = 0; i < arr.length; i++) {
        const initials = arr[i].charAt(0).toUpperCase();
        initialsArray = [...initialsArray, initials];
      }
      initialsFinal = initialsArray;
    } else if (arr.length === 1) {
      initialsFinal = names.charAt(0).toUpperCase();
    }
    // Only display the first two initials
    const onlyTwoAlphabet = initialsFinal.length > 1 ? initialsFinal.slice(0, 2) : initialsFinal;
    return onlyTwoAlphabet;
  }

  useEffect(() => {
    // Set the size dynamically for the avatar
    document.documentElement.style.setProperty('--size', size);
  }, [size]);

  return (
    <div
      className="avatar"
      style={{
        fontSize: fontSize,
        lineHeight: lineHeight,
      }}
    >
      <div
        className="initials-text"
        style={{
          fontSize: fontSize,
          lineHeight: lineHeight,
        }}
      >
        {name && getInitials(name)}
      </div>
    </div>
  );
}

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  fontSize: PropTypes.string.isRequired,
  lineHeight: PropTypes.string.isRequired,
};
